export default {
  cleaning: "Provided\nservices",
  provider: "Provider",
  announcements: "Announcements",
  help: "Help",
  profile: "Profile",
  logout: "Logout",
  cleaning_page_title: "Overview table of all services",
  provider_page_title: "Manage your services and create new service providers",
  announcement_page_title: "Manage your announcements or create a new one",
  location_page_title: "Manage your location group or create a new one",
  profile_page_title: "Profile administration",
  cleaning_subtitle:
    "Here you can see all the services that have been recorded on the digital blackboard. You can filter them by date in ascending / descending order, by location, service provider and activity. It is also possible to export the list as a CSV file for further processing.",
  provider_subtitle:
    "In this area you can create and manage your contracted service providers and assign activities to them.",
  announcement_subtitle:
    "Here you can create and adapt announcements and distribute them to individual or all locations. It is also possible to create or call up templates.",
  location_subtitle:
    "Here you can manage your locations and group them accordingly - for example by district, administrative unit, zip code, etc.",
  profile_subtitle:
    "In this area you can adapt the visual appearance of the service registration on your house boards. The adaptations apply to all your digital blackboards.",
  filter_by: "Filter by",
  newest_first: "Newest first",
  oldest_first: "Oldest first",
  single_days: "Single days",
  show_transferdate: "show received on",
  pick_one_or_more_days: "Pick one or more days",
  to: "To",
  start: "Start",
  end: "End",
  date: "Date",
  location: "Location",
  asc: "Alphabetical ascending",
  desc: "Alphabetical descending",
  search_criteria: "Search criteria",
  service: "Service",
  status: "Status",
  loading: "Loading...",
  locations: "Locations",
  all_services_loaded: "All services have been loaded.",
  last_week: "Last week",
  last_month: "Last month",
  last_3_months: "Last 3 months",
  created_providers: "Created providers",
  delete_provider_confirm: "Are you sure to delete this provider?",
  assigned_services: "Assigned services",
  no_services_assigned: "No services assigned",
  add_new_provider: "Add new provider",
  add_provider: "Add provider",
  edit_provider: "Edit provider",
  enter_data: "Enter data",
  email_address: "Email address",
  pin_for_login: "PIN number for login",
  password_for_login: "Password for online registration",
  password_for_login_missing: "Password for online registration is missing",
  add_service: "Add service(s)",
  cancel: "Cancel",
  save: "Save",
  service_deleted: "Service has been deleted",
  service_created: "Service has been created",
  service_updated: "Service has been updated",
  provider_deleted: "Provider has been deleted",
  provider_updated: "Provider has been updated",
  provider_created: "Provider has been created",
  provider_not_exist: "Provider does not exist",
  enter_password: "Please enter a password",
  enter_name: "Please enter a name",
  enter_username: "Please enter the username",
  enter_group_name: "Please enter a group name",
  enter_description: "Please enter a description",
  enter_email: "Please enter an email",
  enter_valid_email: "Please enter a valid email",
  enter_pin: "Please enter a pin",
  enter_pin_exists: "Pin already exists",
  enter_email_exists: "Email already exists",
  enter_name_exists: "Name already exists",
  announcement_overview: "Overview announcements",
  current: "Current",
  expired: "Expired",
  at: "At",
  till: "Till",
  deleted_announcement_confirm: "Are you sure to delete this announcement?",
  phone: "Phone number",
  restrictions: "Restrictions",
  duty: "Duty to cooperate",
  description_service: "Description of the service",
  select_template: "Select as template",
  create_announcement: "Create a new announcement",
  announcement_information: "Announcement information",
  edit_announcement: "Edit announcement",
  chose_provider: "Choose provider",
  chose_service: "Choose service",
  company: "Company",
  title: "Title",
  period: "Period",
  start_time: "Start time",
  end_time: "End time",
  show_weekend: "show at weekend",
  chose: "Select",
  contact_on_site: "Contact person on site",
  contact_phone: "Contact phone number",
  location_for_announcement: "Location(s) for the announcement",
  single_locations: "Single locations",
  chose_group: "Choose group",
  locations_for_group: "Locations for group",
  locations_for_available: "available on all locations",
  create: "Create",
  select_date: "Please set a date",
  no_title: "Please fill in a title",
  no_description: "Please fill in a description",
  no_company: "Please fill in a company",
  no_contact: "Please fill in a contact person",
  no_start_time: "Please select a start time",
  no_end_time: "Please select an end time",
  no_group: "Please select at least one group",
  no_location: "Please select at least one location",
  no: "No",
  yes: "Yes",
  only_saturday: "only on Saturday",
  only_sunday: "only on Sunday",
  announcement_created: "Announcement succesfully created",
  announcement_changed: "Announcement succesfully changed",
  announcement_deleted: "Announcement succesfully deleted",
  bg_color: "Background color calendar",
  bg_color_service: "Background color service",
  bg_color_today: "Background color „Today“",
  bg_color_announcements: "Background color announcements",
  text_color: "Text color",
  text_color_service: "Text color service",
  text_color_today: "Text color „Today“",
  text_color_announcements: "Text color announcements",
  capture: "Registration",
  preview: "Preview",
  details: "Detailview",
  service_title: "Service title",
  service_subtitle: "Service description",
  visible_for_tenants: "Visible for tenants",
  invisible_for_tenants: "Invisible for tenants",
  multiple_locations: "Cross-location service",
  group_for_service: "Group for service",
  add_group: "Add new group",
  group_name: "Group name",
  delete_service: "Delete service",
  create_service: "Add service",
  edit_service: "Save service",
  select_group_or_create: "Please select a group or create one and select it",
  location_group_created: "Location group has been successfully created",
  login_data: "Login data",
  calender_view_dht: "Calender view digital blackboard",
  upload_logo: "Upload Logo",
  upload_field_text:
    "Drag file here or <em>click here to browse for a file</em>",
  logo_advise: "Logo for the client view (64px Height advised)",
  frontend_view_calendar: "Frontend view Calendar",
  today: "Today",
  logo_updated: "Logo has been updated",
  colors_updated: "Colors have been updated",
  password_updated: "Password has been updated",
  old_password_missmatch: "Old password was not correct",
  colors_update_error: "Could not update colors",
  added_location_groups: "Added location groups",
  delete_group_confirm: "Are you sure to delete this group?",
  assigned_locations: "Assigned locations",
  no_assigned_locations: "no locations have been assigned.",
  add_locations_group: "Add new locations group",
  edit_locations_group: "Edit locations group",
  locations_group_deleted: "Locations group successfully deleted",
  locations_group_changed: "Locations group successfully changed",
  locations_group_added: "Locations group successfully added",
  login_title: "Login for <br>Customer Portal",
  login_failed: "Credentials are not valid.",
  username: "Username",
  password: "Password",
  login: "Login",
  select_client: "Select <br />Your client",
  select_client_text: "Please select a client",
  please_choose: "Please choose",
  continue: "Continue",
  client_not_found: "Client not found",
  user_subtitle: "You can add and manage new users here",
  user_page_title: "User overview",
  created_users: "Created users",
  add_new_user: "Add new user",
  loginname: "Login name",
  add_user: "Add user",
  timetrackingmodule: "Timetracking Module",
  providermodule: "Provider Module",
  delete_user_confirm: "Are you sure you want to delete this user?",
  user_created: "User has been successfully created",
  user_changed: "User has been successfully changed",
  user_deleted: "User has been successfully deleted",
  edit_user: "Edit user",
  site_remote: "SiteRemote Team ID",
  client_urls: "Client URLs",
  client_urls_protection: "URL-Protection",
  client_urls_protection_changed: "URL-Protection changed",
  client_urls_protection_enabled: "enable protection",

  enter_site_remote: "Please enter a SiteRemote Team ID",
  enter_loginname: "Please enter a login name",
  loginname_already_exists: "Login name already exists",
  export_to_csv: "export to CSV",
  shortname: "Shortname",
  not_available: "Not available",
  delete_logo: "Delete logo",
  delete_logo_confirm: "Are you sure you want to delete the logo?",
  logo_deleted: "Logo has been successfully deleted",
  duplicate_group_name: "Group name already exists",
  old_password: "Old Password",
  new_password: "New Password",
  Logout: "Logout",
  provider_onlineaccess: "seperate login for service provider",
  notices_nav: "aquried&nbsp;notices\nfrom service&nbsp;providers",
  notices_tableheader: "aquried notice from service provider",
  notices_page_title: "Overview table of all notices",
  notices_subtitle:
    "Here you can see all the services that have been recorded on the digital blackboard. You can filter them by date in ascending / descending order, by location and service provider. It is also possible to export the list as a CSV file for further processing.",
  notices_field_avaible: "can access notice",
  status_begin: "started",
  status_end: "ended",
  time_schedule: "schedule",
  time_schedule_cycle: "recurring",
  time_schedule_none: "none",
  time_schedule_aktiv: "active",
  time_schedule_weekly: "weekly",
  time_schedule_monthly: "monthly",
  time_schedule_selectdays: "days to show",
  time_schedule_weekcycle: "week cycle",
  time_schedule_monthcycle: "month cycle",

  time_schedule_every_week_1stday: "first chosen weekday in month",
  time_schedule_every_week_2stday: "second chosen weekday in month",
  time_schedule_every_week_3stday: "third chosen weekday in month",
  time_schedule_every_week_4stday: "fourth chosen weekday in month",

  time_schedule_every_week_none: "none weekcycle",
  time_schedule_every_week: "every week",
  time_schedule_every_weekodd: "every odd week",
  time_schedule_every_weekeven: "every even week",
  time_schedule_every_week2: "every 2 weeks",
  time_schedule_every_week3: "every 3 weeks",
  time_schedule_every_week4: "every 4 weeks",

  time_schedule_every_month: "every month",
  time_schedule_every_month2: "every second month",
  time_schedule_every_month3: "every third month",
  time_schedule_every_month4: "every fourth month",
  time_schedule_every_month6: "every sixth month",

  time_schedule_error_day: "Please select at least on Day in week.",
  time_schedule_error_dayinmonth: "Please select the day in month",
  time_schedule_error_plan: "Please select a cycle.",
  time_schedule_error_weekly: "Please select a weeky cycle.",
  time_schedule_error_monthly: "Please select a monthly cycle.",
  time_schedule_lastdayofmonth: "last day in month",
  time_schedule_firstdayofmonth: "first day in month",

  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  editor_site_remote_idteam: "Team Id in editor(old)",
  skonline_site_remote_idteam: "Team Id in skonline/cms(new)",
  users: "Users",
  report: "automatic Reports",
  save_report: "reportsettings saved.",
  save_settings: "settings saved.",
  save_settings_error: "settings could not be saved.",
  profile_settings: "miscellaneous settings",
  send_email_onadd: "e-mail notifcation on add service entry",
  salt: "new secret",
  oldsalt: "old secret",
  olddate: "old secreet valid til",
  getconfiguration_project: "download configuration file for cms",
  getconfiguration_project_copy: "copy to clipboard",
  structurenumber: "Structurenumber",
  can_deleteentries: "Can delete all entries",
  btn_deleteentries: "delete all entries",
  deleteentries_success: "Entries were deleted.",
  deleteentries_fail: "Entries were not deleted.",
  deleteentry_success: "Entry was deleted.",
  deleteentry_fail: "Entry was not deleted.",
  deleteentries_prompt: "Delete all entries?",
  deleteentry_prompt: "Delete this entry?",
  deleteentry_msg: "",
  send_email_notice: "e-mail notifcation on add notice entry",
  setnotice_success: "Notice state was changed.",
  setnotice_fail: "Can not change notice state",
  setnotice_prompt: "Should this notice be marked as done?",
  setnotice_done: "done",
  setnotice_open: "open",
  setnotice_msg: "",
  notice_sort: "only open notice",
  notice_actions: "done",
  actions: "actions",
  showannoucement_inrange_day: "Days left to show an announcement in preview",
  showannoucement_inrange_day_error: "please provider a integer digit",
  showannoucement_inrange_day_notactive: "always displayed"
};
